<template>
    <div class="scroll-vert-season">
        <div v-if="season">
            <h3 class="text-title-bat">{{ season.name }}</h3>
            <h6 class="text-bat">
                {{ season.description }}
            </h6>

            <div class="super-container">
                <div class="p-3">
                    <button class="w-100 mx-1 btn text-title-bat rounded-3 btn-season" @click="showModalReward()">
                        <span>Conoce tu recompensa</span>
                    </button>
                </div>
                <h6 class="text-bat p-2">Realiza las actividades para conservar tu racha</h6>
                <h6 class="text-title-bat mx-2 mb-0">Semanas cumplidas</h6>
                <div class="container-images-left">
                    <div class="left">
                        <div :class="{
                            'images-grid-staff' : isStaffUser,
                            'images-grid' :!isStaffUser
                        }" class=" align-items-center ">
                            <div v-for="(lapse, index) in season.lapses" :key="index" class="image-item"
                                 @click="getLapseActivities(lapse.id)"
                                 :class="{ 'active': selected_lapse === lapse.id }">
                                <img :src="getLapseImageBySegment(lapse)" alt="Imagen">
                                <div class="content-date fw-bold">
                                    <p :class="{ 'text-red': lapse.id === defaultLapseId }">{{ index + 1 }}ª</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <img v-if="isSeasonCompleteActivities" style="width: 60%" src="/img-version2/icons/season/open-chest.png"
                             alt="open-chest">
                        <img v-else style="width: 60%" src="/img-version2/icons/season/closed-chest.png" alt="close-chest">
                    </div>
                </div>
                <div>
                    <h6 class="text-bat p-2" v-if="!isActiveLapse && isSeasonCompleteActivities">
                        <span class="text-won">¡Felicidades!</span> Por tu increíble racha, la has completado con éxito.
                    </h6>
                    <h6 class="text-bat p-2" v-else-if="!isActiveLapse && !isSeasonCompleteActivities">
                        <span class="text-lost">¡No te desanimes!</span> Este mes fue una gran oportunidad para aprender
                        y prepararte para la próxima racha.
                    </h6>
                </div>
                <div class="styled-div m-3">
                    <p>Objetivo: <span class="text-title-bat text-indigo">{{ goalActivities }} actividades</span></p>
                    <div class="position-relative">
                        <el-progress :percentage="progressPercentage || 0" :color="progressColor" :stroke-width="12"
                                     :show-text="false"></el-progress>
                        <div class="progress-dots-season">
                            <div v-for="(dot, index) in dotPositions" :key="index" :style="getDotStyle(dot)"></div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end mt-2">
                        <p class="mb-0">Llevas:<span
                            class="category p-1 px-2 object-fit-contain rounded-2 text-title-bat text-indigo">{{
                                totalActivitiesCompleted }} actividades</span></p>
                    </div>
                </div>
            </div>

            <div>
                <div v-for="activity in activities" :key="activity.id"
                     class="bg-white shadow-sm rounded-4 px-0 mt-4 card-season m-2"
                     @click="handleActivityClick(activity)">
                    <div class="px-2">
                        <div class="justify-content-end rounded-1 top-0 start-0 d-flex flex-row">
                            <div :class="getClassActitivy(activity)">
                                <p class="mb-0 text-indigo-darkness fw-bold">
                                    <small v-if="activity.option == 'survey'">Encuesta</small>
                                    <small v-if="activity.option == 'challenge'">Reto</small>
                                    <small v-if="activity.option == 'learning'">Aprendizaje</small>
                                    <small v-if="activity.option == 'entertainment'">Entretenimiento</small>

                                </p>
                            </div>
                        </div>
                        <h5 v-if="activity.name" class="text-title-bat">
                            {{ activity.name }}
                        </h5>
                        <h5 v-if="activity.title" class="text-title-bat">
                            {{ activity.title }}
                        </h5>
                        <h5 v-if="activity.challenge_name" class="text-title-bat">
                            {{ activity.challenge_name }}
                        </h5>
                        <div class="d-flex justify-content-between my-2">
                            <div class="col-7 text-start pt-2 pb-2 pr-0">
                                <div v-if="activity.option == 'learning'">
                                    <span :class="getClass(activity)" v-if="activity.current_client.length === 0">
                                        ● Por iniciar
                                    </span>
                                    <span class="status-complete-box text-white py-1 px-2 rounded-2 mb-0"
                                          v-else-if="activity.current_client[0].pivot.status === 'completed' && activity.current_client[0].pivot.quiz_presented === 1">
                                        ● Completado
                                    </span>
                                    <span class="bg-orange text-white py-1 px-2 rounded-2 mb-0" v-else>
                                        ● Incompleto
                                    </span>
                                </div>
                                <div v-if="activity.option == 'survey'">
                                    <span :class="getClass(activity)" v-if="activity.current_client.length === 0">
                                        ● Por iniciar
                                    </span>
                                    <span class="bg-orange text-white py-1 px-2 rounded-2 mb-0"
                                          v-else-if="activity.current_client[0].pivot.status === 'pending'">
                                        ● Incompleto
                                    </span>
                                    <span class="status-complete-box text-white py-1 px-2 rounded-2 mb-0"
                                          v-else-if="activity.current_client[0].pivot.status === 'finish'">
                                        ● Completado
                                    </span>
                                </div>
                                <div v-if="activity.option == 'challenge'">
                                    <span :class="getClass(activity)" v-if="activity.current_client.length === 0 || activity.current_client[0].pivot.is_approved === 'read'">
                                        ● Por iniciar
                                    </span>
                                    <span
                                        v-else-if="activity.current_client[0].pivot.is_approved === 'true' || activity.current_client[0].pivot.is_approved === 'false' || activity.current_client[0].pivot.is_approved === 'review'"
                                        class="status-complete-box text-white py-1 px-2 rounded-2 mb-0">
                                        ● Completado
                                    </span>
                                    <span class="bg-orange text-white py-1 px-2 rounded-2 mb-0" v-else>
                                        ● Incompleto
                                    </span>
                                </div>
                                <div v-if="activity.option == 'entertainment'">
                                    <span :class="getClass(activity)" v-if="activity.current_client.length === 0">
                                        ● Por iniciar
                                    </span>
                                    <span
                                        v-else-if="activity.current_client[0].pivot.status === 'true'"
                                        class="status-complete-box text-white py-1 px-2 rounded-2 mb-0">
                                        ● Completado
                                    </span>
                                </div>
                            </div>
                            <div class="col-5 text-end">
                                <span v-if="activity.points_to_win > 0" :class="getClassPoints(activity)">
                                    <b class="fs-6 text-title-bat">
                                        {{ activity.points_to_win }}
                                    </b>
                                    <small class="fs-6 fw-bold">
                                        Pts
                                    </small>
                                </span>
                            </div>
                        </div>
                        <div class="pb-3">
                            <span v-if="showExpirationDate(activity)"
                                  class="my-2 rounded-5 border border-info text-info px-2 py-1 text-btn-outstanding">
                                <img class="mx-1" src="/img/icons/clock_win_points.svg" alt="vencimiento">
                                {{ activityStatus(activity).message }}
                            </span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- Modal de "conoce tu recompensa" -->
        <el-dialog :visible.sync="modalReward" :close-on-press-escape="true" :close-on-click-modal="true"
                   :show-close="true" :center="true" class="modal-locked">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break p-3">
                <img src="/../img-version2/icons/cup.svg" alt="Imagen" class="img-fluid"
                     :class="{ 'img-gray': !award }">
                <h6 v-if="!award" class="mb-1 mt-3 text-bat lh-base">
                    No hemos encontrado un premio asociado a tu racha. Por favor comunícate con el chat de Victoria para
                    más información.
                </h6>
                <div v-else>
                    <h6 v-if="award?.award_for_shopkeeper" class="mb-1 mt-3 text-bat lh-base">Completa todas las
                        actividades
                        y gana la racha con un
                        <br>
                        <span class="py-1 px-2 rounded-1 points mb-0 fs-6 text-bat m-1">
                            <small class="fs-6 fw-bold">
                                {{ award?.product_shopkeeper[0]?.name }}
                            </small>
                        </span>
                    </h6>
                    <h6 v-else class="mb-1 mt-3 text-bat lh-base">Completa todas las actividades y gana la racha con
                        <br>
                        <span class="py-1 px-2 rounded-1 points mb-0 fs-6 text-bat m-1">
                            <b class="fs-6 text-title-bat">
                                {{ award?.points_to_win }}
                            </b>
                            <small class="fs-6 fw-bold">
                                Pts
                            </small>
                        </span>
                        adicionales
                    </h6>
                    <br>
                    <h6 class="text-bat"><strong>Nota importante:</strong> Recuerda que el premio se acreditará a tu
                        cuenta al día siguiente que finalice la racha.</h6>
                </div>
                <br>
                <el-button type="primary" class="btn btnBlue" @click="closeModalReward()">Aceptar</el-button>
            </div>
        </el-dialog>

        <!-- Modal Semana bloqueada -->
        <el-dialog :visible.sync="modalLocked" :close-on-press-escape="true" :close-on-click-modal="true"
                   :show-close="true" :center="true">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break p-3">
                <h5 class="mb-1 mt-3 text-title-bat text-indigo">Semana Bloqueada</h5>
                <h6 class="text-bat">En este momento este contenido no está disponible.</h6>
                <span class="my-2 rounded-5 border border-info text-info px-2 py-1 text-btn-outstanding">
                    <img class="mx-1" src="/img/icons/clock_win_points.svg" alt="vencimiento">
                    Se desbloquea en {{ calculateTime(selected_lapse_start_date) }}
                </span>
                <el-button type="primary" class="btn btnBlue" @click="closeModalLocked()">Aceptar</el-button>
            </div>
        </el-dialog>

        <!-- Modal Actividad bloqueada -->
        <el-dialog :visible.sync="modalLockedActivity" :close-on-press-escape="true" :close-on-click-modal="true"
                   :show-close="true" :center="true">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break p-3">
                <h5 class="mb-1 mt-3 text-title-bat text-indigo">Actividad Bloqueada</h5>
                <h6 class="text-bat">En este momento este contenido no está disponible.</h6>
                <span class="my-2 rounded-5 border border-info text-info px-2 py-1 fw-bold text-btn-outstanding">
                    <img class="mx-1" src="/img/icons/clock_win_points.svg" alt="vencimiento">
                    Se desbloquea en {{ calculateTime(selected_activity_start_date) }}
                </span>
                <el-button type="primary" class="btn btnBlue" @click="closeModalLockedActivity()">Aceptar</el-button>
            </div>
        </el-dialog>

        <!-- Actividad completada -->
        <el-dialog :visible.sync="modalActivityCompleted" :close-on-press-escape="true" :close-on-click-modal="true"
                   :show-close="true" :center="true">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break p-3">
                <h5 class="mb-1 mt-3 text-title-bat text-indigo">Actividad Completada</h5>
                <h6 class="text-bat">Esta actividad ya ha sido completada. No se puede acceder a ella en este momento.
                </h6>
                <el-button type="primary" class="btn btnBlue"
                           @click="modalActivityCompleted = false">Aceptar</el-button>
            </div>
        </el-dialog>

        <!-- Actividad vencida -->
        <el-dialog :visible.sync="modalActivityExpired" :close-on-press-escape="true" :close-on-click-modal="true"
                   :show-close="true" :center="true">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break p-3">
                <h5 class="mb-1 mt-3 text-title-bat text-indigo">Actividad Vencida</h5>
                <h6 class="text-bat">Esta actividad ha vencido y ya no está disponible para acceso.</h6>
                <el-button type="primary" class="btn btnBlue" @click="modalActivityExpired = false">Aceptar</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
export default {
    props: {
        season_id: {
            default: 0,
        },
        staff_segments: {
            default: 0,
        },
        client_segment: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            loading: 0,
            season: null,
            activities: [],
            current_date: null,
            selected_lapse: null,
            defaultLapseId: null,
            goalActivities: 0,
            totalActivitiesCompleted: 0,

            inactiveLapses: [],
            modalReward: false,
            modalLocked: false,
            modalLockedActivity: false,
            modalActivityExpired: false,
            modalActivityCompleted: false,
            selected_activity_start_date: null,
            selected_lapse_start_date: null,
            award: 0,
            dotPositions: [30, 43, 57, 70],

            activeLapse: null,

            isSeasonComplete: false,
            isFinalLapse: false,
        }
    },
    mounted() {
        this.getSeasonData()

        // this.goalActivities = this.totalActivitiesSeason;
        // this.totalActivitiesCompleted = this.totalActivitiesCompletedSeason;

    },
    computed: {
        progressPercentage() {
            const percentage = this.goalActivities === 0 ? 0 : (this.totalActivitiesCompleted / this.goalActivities) * 100;
            return Math.min(Math.max(percentage, 0), 100);
        },
        totalActivitiesSeason() {
            if (!this.season || !this.season.lapses) {
                return 0;
            }
            return this.season.lapses.reduce((total, lapse) => total + (lapse.activities || 0), 0);
        },

        totalActivitiesCompletedSeason() {
            if (!this.season || !this.season.lapses) {
                return 0;
            }
            return this.season.lapses.reduce((total, lapse) => {
                if (lapse.current_client) {
                    return total + lapse.current_client.reduce((clientTotal, client) => clientTotal + (client.pivot.completed_activities || 0), 0);
                }
                return total;
            }, 0);
        },
        isSeasonCompleteActivities() {
            const result = this.totalActivitiesSeason === this.totalActivitiesCompletedSeason;
            return result;
        },
        isLastLapse() {
            if (!this.season || !this.season.lapses) return false;
            const lapses = this.season.lapses;
            const lastLapse = lapses[lapses.length - 1];
            const current_date = this.current_date ? new Date(this.current_date) : new Date();

            const result = current_date >= new Date(lastLapse.start_date) && current_date <= new Date(lastLapse.end_date);
            return result;
        },
        isActiveLapse() {
            if (!this.season || !this.season.lapses) return false;
            const result = this.season.lapses.some(lapse => {
                const startDate = new Date(lapse.start_date);
                const endDate = new Date(lapse.end_date);
                const current_date = this.current_date ? new Date(this.current_date) : new Date();

                return current_date >= startDate && current_date <= endDate;
            });
            return result;
        },
        isStaffUser() {
            const isStaff = this.staff_segments.includes(this.client_segment);
            return isStaff;
        }

    },
    methods: {
        getSeasonData() {
            this.loading++
            axios.get(`/get-season-data/${this.season_id}`)
                .then(({ data }) => {
                    this.season = data.season;
                    this.current_date = data.current_date;
                    this.award = data.award;
                    this.loading--
                    this.checkActiveLapse()
                })
        },
        checkActiveLapse() {

            if (!this.season || !this.season.lapses || this.season.lapses.length === 0) {
                return;
            }

            this.inactiveLapses = [];
            const current_date = this.current_date ? new Date(this.current_date) : new Date();

            for (const lapse of this.season.lapses) {
                const startDate = new Date(lapse.start_date);
                const endDate = new Date(lapse.end_date);

                if (current_date >= startDate && current_date <= endDate) {
                    this.activeLapse = lapse;
                    break;
                }

            }

            if (this.activeLapse == null && this.season.lapses.length > 0) {
                // this.activeLapse = this.season.lapses[0];
                this.activeLapse = this.season.lapses[this.season.lapses.length - 1];
            }

            if (this.activeLapse) {
                this.defaultLapseId = this.activeLapse.id;
                this.selected_lapse = this.activeLapse.id;
                this.getLapseActivities(this.activeLapse.id);
            }

            this.inactiveLapses = this.season.lapses.filter(lapse => lapse.id !== this.activeLapse?.id);
        },

        getLapseActivities(lapse_id) {
            if (!this.season || !this.season.lapses) {
                this.modalLocked = true;
                return;
            }

            const selectedLapse = this.season.lapses.find(lapse => lapse.id === lapse_id);

            if (!selectedLapse) {
                this.modalLocked = true;
                return;
            }

            const lapseStartDate = new Date(selectedLapse.start_date);
            const current_date = this.current_date ? new Date(this.current_date) : new Date();

            const currentDate = new Date(current_date);
            if (lapseStartDate > currentDate) {
                this.selected_lapse_start_date = lapseStartDate;
                this.modalLocked = true;
                return;
            }

            this.selected_lapse = lapse_id;
            this.selected_lapse_start_date = lapseStartDate;
            this.loading++;

            axios.get(`/get-lapse-activities/${this.selected_lapse}`)
                .then(({ data }) => {
                    /* this.activities = data.activities || []*/

                    this.activities = (data.activities || []).filter(activity => activity.has_quiz !== 0);

                    this.goalActivities = this.activities.length;

                    this.totalActivitiesCompleted = this.activities.reduce((total, activity) => {
                        let isCompleted = false;

                        // Validaciones para determinar si la actividad está completada
                        if (activity.option === 'challenge') {
                            // Validación "challenge"
                            if (activity.current_client && activity.current_client.length > 0) {
                                const client = activity.current_client[0];
                                isCompleted = client.pivot.is_approved === 'true' ||
                                    client.pivot.is_approved === 'false' ||
                                    client.pivot.is_approved === 'review';
                            }
                        } else if (activity.option === 'learning') {
                            if (activity.current_client && activity.current_client.length > 0) {
                                const client = activity.current_client[0];
                                isCompleted = client.pivot.status === 'completed' &&
                                    client.pivot.quiz_presented === 1;
                            }
                        } else if (activity.option === 'finish') {
                            if (activity.current_client && activity.current_client.length > 0) {
                                const client = activity.current_client[0];
                                isCompleted = client.pivot.status === 'finish';
                            }
                        } else if (activity.option === 'survey') {
                            if (activity.current_client && activity.current_client.length > 0) {
                                const client = activity.current_client[0];
                                isCompleted = client.pivot.status === 'finish';
                            }
                        } else if (activity.option === 'entertainment') {
                            if (activity.current_client && activity.current_client.length > 0) {
                                const client = activity.current_client[0];
                                isCompleted = client.pivot.status === 'true';
                            }
                        }

                        return total + (isCompleted ? 1 : 0);
                    }, 0);
                    this.loading--;
                })
                .catch(() => {
                    this.loading--;
                });
        },

        getDotStyle(percentage) {
            const position = Math.min(Math.max(percentage, 0), 100) + '%';
            return {
                left: position,
                top: '50%',
                transform: 'translate(-50%, -50%)'
            };
        },

        progressColor() {
            const current_date = this.current_date ? new Date(this.current_date) : new Date();
            const lapseEndDate = this.lapse ? new Date(this.lapse.end_date) : null;

            if (this.goalActivities === 0) {
                return '#FF0000'; // Rojo si no hay actividades
            }

            // Verificar si el lapso ha terminado
            if (lapseEndDate && current_date > lapseEndDate) {
                const hasExpiredActivities = this.activities.some(activity => {
                    return new Date(activity.expiration_date_end) < current_date && !activity.completed;
                });

                // Si hay actividades vencidas
                if (hasExpiredActivities) {
                    // Si todas las actividades fueron completadas
                    if (this.totalActivitiesCompleted === this.goalActivities) {
                        return '#FF0000'; // Rojo si hay actividades vencidas
                    }

                    // Si se completaron algunas actividades pero hay actividades vencidas
                    if (this.totalActivitiesCompleted > 0) {
                        return '#FF0000'; // Rojo si hay actividades vencidas
                    }
                } else {
                    // Si no hay actividades vencidas y el lapso ha terminado
                    if (this.totalActivitiesCompleted === this.goalActivities) {
                        return '#83D300'; // Verde si se completaron todas las actividades y no hay vencidas
                    }
                }
            } else {
                // Si el lapso no ha terminado
                if (this.totalActivitiesCompleted >= this.goalActivities) {
                    return '#83D300'; // Verde si se completaron todas las actividades
                }

                if (this.totalActivitiesCompleted >= (this.goalActivities / 2)) {
                    // Verifica si hay actividades vencidas cuando el lapso no ha terminado
                    const hasExpiredActivities = this.activities.some(activity => {
                        return new Date(activity.expiration_date_end) < current_date && !activity.completed;
                    });

                    if (hasExpiredActivities) {
                        return '#FF0000'; // Rojo si hay actividades vencidas
                    }
                    return '#00B5F3'; // Azul si se completó al menos la mitad de las actividades y no hay vencidas
                }

                // Si se ha completado al menos una actividad y no se ha vencido el lapso
                if (this.totalActivitiesCompleted > 0) {
                    return '#FF0000'; // Rojo si hay actividades incompletas
                }
            }
            return '#FF0000';
        },

        calculateTime(date) {
            const current_date = this.current_date ? new Date(this.current_date) : new Date();
            const targetDate = new Date(date);
            const diffTime = targetDate - current_date;

            if (diffTime <= 0) {
                return 'ya disponible';
            }

            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));

            if (diffDays > 0) {
                return `${diffDays} día${diffDays > 1 ? 's' : ''}`;
            } else if (diffHours > 0) {
                return `${diffHours} horas`;
            } else if (diffMinutes > 0) {
                return `${diffMinutes} minutos`;
            } else {
                return 'hoy';
            }
        },
        activityStatus(activity) {
            const current_date = this.current_date ? new Date(this.current_date) : new Date();
            const startDate = new Date(activity.expiration_date_start);
            const endDate = new Date(activity.expiration_date_end);

            let message;
            let color;

            if (current_date < startDate) {
                // La actividad aún no ha comenzado
                message = `Se activará en ${this.calculateTime(activity.expiration_date_start)}`;
            } else if (current_date > endDate) {
                // La actividad ha vencido
                message = `Tiempo vencido.`;
            } else if (current_date > startDate && current_date < endDate) {
                message = `Vencerá en ${this.calculateTime(activity.expiration_date_end)}`;
            } else {
                // La actividad está en curso
                message = `Tu ${activity.option === 'survey' ? 'encuesta' :
                    activity.option === 'challenge' ? 'reto' :
                        activity.option === 'entertainment' ? 'entretenimiento' :
                            'aprendizaje'} inicia ${this.calculateTime(activity.expiration_date_start)}`;
            }

            return { message, color };
        },
        getLapseImage(lapse) {
            const currentDate = this.current_date ? new Date(this.current_date) : new Date();
            const lapseEndDate = new Date(lapse.end_date);
            const lapseStartDate = new Date(lapse.start_date);


            if (currentDate < lapseStartDate) {
                // Antes de que comience el lapso
                return '/img-version2/icons/season/season-blue-rocket.svg'; //llave azul
            } else if (currentDate >= lapseStartDate && currentDate <= lapseEndDate) {
                // Durante el lapso
                if (lapse.current_client.length && lapse.current_client[0].pivot.completed_activities == lapse.activities) {
                    return '/img-version2/icons/season/season-green-rocket.svg';
                } else {
                    return '/img-version2/icons/season/season-orange-rocket.svg'; //llave amarilla
                }
            } else if (currentDate > lapseEndDate) {
                // Después del lapso

                if (lapse.current_client.length && lapse.current_client[0].pivot.completed_activities == lapse.activities) {
                    return '/img-version2/icons/season/season-green-rocket.svg';
                } else {
                    return '/img-version2/icons/season/season-gray-rocket.svg';
                }

            } else {
                return '/img-version2/icons/season/season-orange-rocket.svg';
            }
        },

        handleLapseClick(lapse) {
            const isActiveLapse = lapse.id === this.defaultLapseId;
            if (isActiveLapse) {
                this.getLapseActivities(lapse.id);

            } else {
                this.selected_lapse_start_date = lapse.start_date
                this.modalLocked = true;

            }
        },

        handleActivityClick(activity) {
            const expirationDateStart = new Date(activity.expiration_date_start);
            const expirationDateEnd = new Date(activity.expiration_date_end);
            const currentDate = this.current_date ? new Date(this.current_date) : new Date();
            const isCompleted = activity.current_client && activity.current_client.length > 0;

            if (expirationDateStart > currentDate) {
                // La actividad aún no ha comenzado
                this.selected_activity_start_date = activity.expiration_date_start;
                this.modalLockedActivity = true;
            } else if (expirationDateEnd < currentDate) {
                // La actividad ha vencido
                this.modalActivityExpired = true;
            } else if (isCompleted) {
                const client = activity.current_client[0];
                if (client && client.pivot) {
                    if (activity.option === 'learning') {
                        if (client.pivot.status === 'completed' && client.pivot.quiz_presented === 1) {
                            this.modalActivityCompleted = true;
                        } else {
                            window.location.href = `learning/${activity.id}`;
                        }
                    } else if (activity.option === 'challenge') {
                        if (client.pivot.is_approved === 'true' || client.pivot.is_approved === 'false' || client.pivot.is_approved === 'review') {
                            this.modalActivityCompleted = true;
                        } else {
                            if (client.pivot.is_approved === 'read') {
                                switch (activity.challenge_type_id) {
                                    case 1:
                                        window.location.href = `retos/foto/${activity.id}`;
                                        break;
                                    case 4:
                                        window.location.href = `retos/sopa-letras/${activity.id}`;
                                        break;
                                    case 6:
                                        window.location.href = `retos/memento/${activity.id}`;
                                        break;
                                    default:
                                        window.location.href = `retos?page=1&option=challenge`;
                                        break;
                                }
                            } else {
                                if (activity.challenge_type_id === 1) {
                                    window.location.href = `retos/foto/${activity.id}`;
                                } else if (activity.challenge_type_id === 4) {
                                    window.location.href = `retos/sopa-letras/${activity.id}`;
                                } else if (activity.challenge_type_id === 6) {
                                    window.location.href = `retos/memento/${activity.id}`;
                                }
                            }
                        }
                    } else if (activity.option === 'survey') {
                        if (client.pivot.status === 'finish') {
                            // Mostrar modal si status es 'finish'
                            this.modalActivityCompleted = true;
                        } else {
                            // Redirigir si el status no es 'finish'
                            window.location.href = `survey/${activity.id}`;
                        }

                    } else if (activity.option === 'entertainment') {
                        if (client.pivot.status === 'true') {
                            this.modalActivityCompleted = true;
                        } else {
                            window.location.href = `entertainment/${activity.id}`;
                        }
                    }
                } else {
                    // Si client o client.pivot no están definidos, redirigir a la actividad correspondiente
                    if (activity.option === 'learning') {
                        window.location.href = `learning/${activity.id}`;
                    } else if (activity.option === 'challenge') {
                        if (activity.challenge_type_id === 1) {
                            window.location.href = `retos/foto/${activity.id}`;
                        } else if (activity.challenge_type_id === 4) {
                            window.location.href = `retos/sopa-letras/${activity.id}`;
                        } else if (activity.challenge_type_id === 6) {
                            window.location.href = `retos/memento/${activity.id}`;
                        }
                    } else if (activity.option === 'survey') {
                        window.location.href = `survey/${activity.id}`;
                    } else if (activity.option === 'entertainment') {
                        window.location.href = `entertainment/search_character/${activity.id}`;
                    }

                }
            } else {
                // La actividad no está completa
                if (activity.option === 'learning') {
                    window.location.href = `learning/${activity.id}`;
                } else if (activity.option === 'challenge') {
                    if (activity.challenge_type_id === 1) {
                        window.location.href = `retos/foto/${activity.id}`;
                    } else if (activity.challenge_type_id === 4) {
                        window.location.href = `retos/sopa-letras/${activity.id}`;
                    } else if (activity.challenge_type_id === 6) {
                        window.location.href = `retos/memento/${activity.id}`;
                    }
                } else if (activity.option === 'survey') {
                    window.location.href = `survey/${activity.id}`;
                } else if (activity.option === 'entertainment') {
                    window.location.href = `entertainment/search_character/${activity.id}`;
                }
            }
        },
        getClass(activity) {
            const expirationDateStart = new Date(activity.expiration_date_start);
            const current_date = this.current_date ? new Date(this.current_date) : new Date();

            return {
                'bg-darkgray': expirationDateStart >= current_date,
                'bg-darkblue': expirationDateStart < current_date,
                'text-white': true,
                'py-1': true,
                'px-2': true,
                'rounded-2': true,
                'mb-0': true,
            };
        },
        getClassPoints(activity) {
            const expirationDateStart = new Date(activity.expiration_date_start);
            const current_date = this.current_date ? new Date(this.current_date) : new Date();

            return {
                'bg-darkgray': expirationDateStart >= current_date,
                'points': expirationDateStart < current_date,
                'text-bat': true,
                'py-1': true,
                'px-2': true,
                'rounded-1': true,
                'mb-0': true,
            };
        },
        getClassActitivy(activity) {
            const expirationDateStart = new Date(activity.expiration_date_start);
            const current_date = this.current_date ? new Date(this.current_date) : new Date();

            return {
                'bg-darkgray': expirationDateStart >= current_date,
                'category': expirationDateStart < current_date,
                'py-1': true,
                'px-2': true,
                'rounded-2': true,
                'object-fit-contain': true,
                'text-bat': true
            };
        },
        showModalReward() {
            this.modalReward = true
        },

        closeModalReward() {
            this.modalReward = false;
        },

        closeModalLocked() {
            this.modalLocked = false;
        },
        closeModalLockedActivity() {
            this.modalLockedActivity = false;
        },
        showExpirationDate(activity) {
            let isCompleted = false;

            if (activity.current_client && activity.current_client.length > 0) {
                const client = activity.current_client[0];

                if (activity.option === 'learning') {
                    isCompleted = (client.pivot.status === 'completed' && client.pivot.quiz_presented === 1);
                } else if (activity.option === 'challenge') {
                    isCompleted = (client.pivot.is_approved === 'true' ||
                        client.pivot.is_approved === 'false' ||
                        client.pivot.is_approved === 'review');
                } else if (activity.option === 'survey') {
                    isCompleted = (client.pivot.status === 'finish');
                } else if (activity.option === 'entertainment') {
                    isCompleted = (client.pivot.status === 'true');
                }
            }

            return !isCompleted;
        },

        //Racha para STAFF
        getStaffLapseImage(lapse) {
            const currentDate = this.current_date ? new Date(this.current_date) : new Date();
            const lapseEndDate = new Date(lapse.end_date);
            const lapseStartDate = new Date(lapse.start_date);

            const clientCompletedAll =
                lapse.current_client.length &&
                lapse.current_client[0].pivot.completed_activities === lapse.activities;

            if (currentDate < lapseStartDate) {
                return '/img-version2/icons/season-staff/blocked-flame.png';
            } else if (currentDate >= lapseStartDate && currentDate <= lapseEndDate) {
                return clientCompletedAll
                    ? '/img-version2/icons/season-staff/season-won.gif'
                    : '/img-version2/icons/season-staff/season-current.gif';
            } else if (currentDate > lapseEndDate) {
                return clientCompletedAll
                    ? '/img-version2/icons/season-staff/season-won.gif'
                    : '/img-version2/icons/season-staff/gray-flame.png';
            } else {
                return '/img-version2/icons/season-staff/season-current.gif';
            }
        },
        getLapseImageBySegment(lapse) {
            return this.isStaffUser
                ? this.getStaffLapseImage(lapse)
                : this.getLapseImage(lapse);
        }

    }
}
</script>
